import React, { FC } from 'react';
import { FormField, FormFieldProps } from '../FormField';
import { TimePicker } from '..';

export type FormTimePickerProps = FormFieldProps;

export const FormTimePicker: FC<FormTimePickerProps> = ({ ...props }) => {
	return <FormField control={TimePicker} {...props} />;
};
